import React from "react";
import "./Header.scss";

const Header = () => (
    <h1 className="headerTitle">Selvitä paljonko koodarin palkka on</h1>
);

export default Header;
